/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getSeller = /* GraphQL */ `
  query GetSeller($id: ID!) {
    getSeller(id: $id) {
      id
      email
      name
      stripeID
      invoiceRegistrationNumber
      address
      phone
      postal
      createdAt
      updateAt
      products {
        items {
          id
          title
          sellerID
          stripeID
          URL
          price
          mailtext
          description
          note
          form
          imgURL
          stopFlag
          disableFlag
          identityId
          updatedAt
          createdAt
        }
        scannedCount
        nextToken
      }
    }
  }
`;
export const listSellers = /* GraphQL */ `
  query ListSellers($limit: Int, $nextToken: String, $sortDirection: Boolean) {
    listSellers(
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        email
        name
        stripeID
        address
        phone
        postal
        createdAt
        updateAt
        products {
          scannedCount
          nextToken
        }
      }
      scannedCount
      nextToken
    }
  }
`;
export const countAllSellers = /* GraphQL */ `
  query CountAllSellers($nextToken: String) {
    countAllSellers(nextToken: $nextToken) {
      items {
        id
        email
        name
        stripeID
        address
        phone
        postal
        createdAt
        updateAt
        products {
          scannedCount
          nextToken
        }
      }
      scannedCount
      nextToken
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      title
      sellerID
      stripeID
      seller {
        id
        email
        name
        stripeID
        address
        phone
        postal
        createdAt
        updateAt
        products {
          scannedCount
          nextToken
        }
      }
      URL
      price
      quantity
      mailtext
      description
      note
      form
      imgURL
      stopFlag
      disableFlag
      identityId
      updatedAt
      createdAt
      customers {
        items {
          id
          productID
          email
          name
          note
          created_at
          chargeID
          reqRefund
          refundComment
          answer
          cancelled_at
        }
        scannedCount
        nextToken
      }
    }
  }
`;
export const getProductWithoutCustomers = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      title
      sellerID
      stripeID
      URL
      price
      mailtext
      description
      note
      form
      imgURL
      stopFlag
      disableFlag
      identityId
      updatedAt
      createdAt
    }
  }
`;
export const queryCustomersByProductID = /* GraphQL */ `
  query QueryCustomersByProductID($productID: ID!, $limit: Int) {
    queryCustomersByProductID(productID: $productID, limit: $limit) {
      items {
        id
        productID
        email
        name
        created_at
        chargeID
        note
        cancelled_at
        reqRefund
        refundComment
        answer
      }
      scannedCount
      nextToken
    }
  }
`;

export const getProductBySellerId = /* GraphQL */ `
  query GetProductBySellerId($sellerID: ID!, $limit: Int, $nextToken: String) {
    getProductBySellerID(
      sellerID: $sellerID
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        sellerID
        stripeID
        seller {
          id
          email
          name
          stripeID
          address
          phone
          postal
          createdAt
          updateAt
        }
        URL
        price
        mailtext
        description
        note
        form
        imgURL
        stopFlag
        disableFlag
        identityId
        updatedAt
        createdAt
        customers {
          scannedCount
          nextToken
        }
      }
      scannedCount
      nextToken
    }
  }
`;
export const countProductBySellerId = /* GraphQL */ `
  query CountProductBySellerId($sellerID: ID!, $nextToken: String) {
    countProductBySellerID(sellerID: $sellerID, nextToken: $nextToken) {
      items {
        id
        title
        sellerID
        stripeID
        seller {
          id
          email
          name
          stripeID
          address
          phone
          postal
          createdAt
          updateAt
        }
        URL
        price
        mailtext
        description
        note
        form
        imgURL
        stopFlag
        disableFlag
        identityId
        updatedAt
        createdAt
        customers {
          scannedCount
          nextToken
        }
      }
      scannedCount
      nextToken
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts($limit: Int, $nextToken: String, $sortDirection: Boolean) {
    listProducts(
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        title
        sellerID
        stripeID
        seller {
          id
          email
          name
          stripeID
          address
          phone
          postal
          createdAt
          updateAt
        }
        URL
        price
        mailtext
        description
        note
        form
        imgURL
        stopFlag
        disableFlag
        identityId
        updatedAt
        createdAt
        customers {
          scannedCount
          nextToken
        }
      }
      scannedCount
      nextToken
    }
  }
`;

export const listProductsWithoutCustomers = /* GraphQL */ `
  query ListProductsWithoutCustomers($limit: Int, $nextToken: String) {
    listProducts(limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        price
      }
      nextToken
    }
  }
`;

export const countAllProducts = /* GraphQL */ `
  query CountAllProducts($nextToken: String) {
    countAllProducts(nextToken: $nextToken) {
      items {
        id
        title
        sellerID
        stripeID
        seller {
          id
          email
          name
          stripeID
          address
          phone
          postal
          createdAt
          updateAt
        }
        URL
        price
        mailtext
        description
        note
        form
        imgURL
        stopFlag
        disableFlag
        identityId
        updatedAt
        createdAt
        customers {
          scannedCount
          nextToken
        }
      }
      scannedCount
      nextToken
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      productID
      product {
        id
        title
        sellerID
        stripeID
        seller {
          id
          email
          name
          stripeID
          address
          phone
          postal
          createdAt
          updateAt
        }
        URL
        price
        mailtext
        description
        note
        form
        imgURL
        stopFlag
        disableFlag
        identityId
        updatedAt
        createdAt
        customers {
          scannedCount
          nextToken
        }
      }
      email
      name
      note
      created_at
      chargeID
      reqRefund
      refundComment
      answer
      cancelled_at
    }
  }
`;
export const getCustomerByProductId = /* GraphQL */ `
  query GetCustomerByProductId(
    $productID: ID!
    $limit: Int
    $nextToken: String
  ) {
    getCustomerByProductID(
      productID: $productID
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productID
        product {
          id
          title
          sellerID
          stripeID
          URL
          price
          mailtext
          description
          note
          form
          imgURL
          stopFlag
          disableFlag
          identityId
          updatedAt
          createdAt
        }
        email
        name
        note
        created_at
        chargeID
        reqRefund
        refundComment
        answer
        cancelled_at
      }
      scannedCount
      nextToken
    }
  }
`;
export const countCustomerByProductId = /* GraphQL */ `
  query CountCustomerByProductId($productID: ID!, $nextToken: String) {
    countCustomerByProductID(productID: $productID, nextToken: $nextToken) {
      items {
        id
        productID
        product {
          id
          title
          sellerID
          stripeID
          URL
          price
          mailtext
          description
          note
          form
          imgURL
          stopFlag
          disableFlag
          identityId
          updatedAt
          createdAt
        }
        email
        name
        note
        created_at
        chargeID
        reqRefund
        refundComment
        answer
        cancelled_at
      }
      scannedCount
      nextToken
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productID
        product {
          id
          title
          sellerID
          stripeID
          URL
          price
          mailtext
          description
          note
          form
          imgURL
          stopFlag
          disableFlag
          identityId
          updatedAt
          createdAt
        }
        email
        name
        note
        created_at
        chargeID
        reqRefund
        refundComment
        answer
        cancelled_at
      }
      scannedCount
      nextToken
    }
  }
`;
export const getProvide6tmev5bluvberlff7ql57zqxu4Pittaput = /* GraphQL */ `
  query GetProvide6tmev5bluvberlff7ql57zqxu4Pittaput($id: ID!) {
    getProvide6tmev5bluvberlff7ql57zqxu4Pittaput(id: $id) {
      id
      productID
      sellerID
      sellerName
      sellerPostal
      sellerAddress
      sellerPhone
      CustomerName
      ProvideItems
      TimeToLive
    }
  }
`;
export const listProvide6tmev5bluvberlff7ql57zqxu4Pittaputs = /* GraphQL */ `
  query ListProvide6tmev5bluvberlff7ql57zqxu4Pittaputs(
    $filter: TableProvide6tmev5bluvberlff7ql57zqxu4PittaputFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProvide6tmev5bluvberlff7ql57zqxu4Pittaputs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productID
        sellerID
        sellerName
        sellerPostal
        sellerAddress
        sellerPhone
        CustomerName
        ProvideItems
        TimeToLive
      }
      nextToken
    }
  }
`;
export const queryProvide6tmev5bluvberlff7ql57zqxu4PittaputsByProductIdIndex = /* GraphQL */ `
  query QueryProvide6tmev5bluvberlff7ql57zqxu4PittaputsByProductIdIndex(
    $productID: ID!
    $first: Int
    $after: String
  ) {
    queryProvide6tmev5bluvberlff7ql57zqxu4PittaputsByProductIDIndex(
      productID: $productID
      first: $first
      after: $after
    ) {
      items {
        id
        productID
        sellerID
        sellerName
        sellerPostal
        sellerAddress
        sellerPhone
        CustomerName
        ProvideItems
        TimeToLive
      }
      nextToken
    }
  }
`;
export const queryProvide6tmev5bluvberlff7ql57zqxu4PittaputsBySellerIdIndex = /* GraphQL */ `
  query QueryProvide6tmev5bluvberlff7ql57zqxu4PittaputsBySellerIdIndex(
    $sellerID: ID!
    $first: Int
    $after: String
  ) {
    queryProvide6tmev5bluvberlff7ql57zqxu4PittaputsBySellerIDIndex(
      sellerID: $sellerID
      first: $first
      after: $after
    ) {
      items {
        id
        productID
        sellerID
        sellerName
        sellerPostal
        sellerAddress
        sellerPhone
        CustomerName
        ProvideItems
        TimeToLive
      }
      nextToken
    }
  }
`;
export const getAdmin6tmev5bluvberlff7ql57zqxu4Pittaput = /* GraphQL */ `
  query GetAdmin6tmev5bluvberlff7ql57zqxu4Pittaput($id: String!) {
    getAdmin6tmev5bluvberlff7ql57zqxu4Pittaput(id: $id) {
      id
      name
    }
  }
`;
export const listAdmin6tmev5bluvberlff7ql57zqxu4Pittaputs = /* GraphQL */ `
  query ListAdmin6tmev5bluvberlff7ql57zqxu4Pittaputs(
    $filter: TableAdmin6tmev5bluvberlff7ql57zqxu4PittaputFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAdmin6tmev5bluvberlff7ql57zqxu4Pittaputs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
      }
      nextToken
    }
  }
`;
export const getSelling6tmev5bluvberlff7ql57zqxu4Pittaput = /* GraphQL */ `
  query GetSelling6tmev5bluvberlff7ql57zqxu4Pittaput(
    $month: Int!
    $date: Int!
  ) {
    getSelling6tmev5bluvberlff7ql57zqxu4Pittaput(month: $month, date: $date) {
      date
      month
      customers
      selling
    }
  }
`;

export const listSellingByDate = /* GraphQL */ `
  query ListSellingByDate(
    $month: Int!
    $startDate: Int!
    $endDate: Int!
    $limit: Int
    $nextToken: String
  ) {
    listSellingByDate(
      month: $month
      startDate: $startDate
      endDate: $endDate
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        date
        month
        customers
        selling
      }
      nextToken
    }
  }
`;

export const listSelling6tmev5bluvberlff7ql57zqxu4Pittaputs = /* GraphQL */ `
  query ListSelling6tmev5bluvberlff7ql57zqxu4Pittaputs(
    $filter: TableSelling6tmev5bluvberlff7ql57zqxu4PittaputFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSellingByDate(
        month: $month,
        startDate: $startDate,
        endDate: $endDate,
        limit: $limit,
        nextToken: $nextToken
    ) {
      items {
        date
        month
        customers
        selling
      }
      nextToken
    }
  }
`;
